import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { DEFAULT_CURRENCY } from '../../../constants/default.mjs';
import { useMoimCommonContext } from '../../../contexts/index.mjs';
import { useCurrentCurrencyRule } from '../../../hooks/commerce/index.mjs';
import { formatClassifiedCurrency } from './helper.mjs';
import { Wrapper } from './styled.mjs';

var CurrencyFormatter = function CurrencyFormatter(_ref) {
  var prefix = _ref.prefix,
    currencyProps = _ref.currency,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    className = _ref.className,
    children = _ref.children;
  var _a;
  var defaultCurrency = useMoimCommonContext(function (state) {
    return state.currency;
  });
  var currency = (_a = currencyProps !== null && currencyProps !== void 0 ? currencyProps : defaultCurrency) !== null && _a !== void 0 ? _a : DEFAULT_CURRENCY;
  var upperCaseCurrency = currency.toUpperCase();
  var currencyRule = useCurrentCurrencyRule(upperCaseCurrency);
  if (isNaN(Number(value))) {
    return jsx(Fragment, {
      children: value
    });
  }
  var numValue = Number(value);
  var _formatClassifiedCurr = formatClassifiedCurrency(currencyRule, numValue, currency),
    formattedValue = _formatClassifiedCurr.formattedValue,
    groupedValue = _formatClassifiedCurr.groupedValue,
    symbol = _formatClassifiedCurr.symbol;
  return jsxs(Wrapper, {
    className: className,
    children: [Boolean(prefix) && prefix, children ? children({
      value: groupedValue,
      currency: upperCaseCurrency,
      symbol: symbol
    }) : formattedValue]
  });
};

export { CurrencyFormatter };
